// Page: Integrations
if ($('body').hasClass('page--integrations')) {

  const $input = $('.js-suggestion-form-input');

  $('.js-suggestion-form').on('submit', function () {
    const successMessage = $('.new-suggestion-box__success');
    const errorMessage = $('.error-message--global');
    const suggestion = $input.val().trim();
    if (suggestion.length == 0) {
      $input.focus();
      return false;
    }
    $.ajax({
      type: "POST",
      url: "/api/site/integrations/suggest",
      data: {
        'suggestion': suggestion
      },
      success: function () {
        $input.val('');
        successMessage.html(Cacoo.SiteResources["integration_suggestion_success"]);

        $.Velocity.animate(successMessage, {
          opacity: 1
        }, {
          visibility: "visible"
        });

      },
      error: function (err) {
        if (!err.errors) {
          errorMessage.html(Cacoo.SiteResources["modal_signup_default_error"])
        } else {
          errorMessage.html(message);
        }
      }
    });
    return false;
  })
}
